import { render, staticRenderFns } from "./UrlUpload.vue?vue&type=template&id=44c4909c&"
import script from "./UrlUpload.vue?vue&type=script&lang=js&"
export * from "./UrlUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports